import React from 'react';
import styles from './NexsetOverview.module.scss';
import { Typography } from '@mui/material';
import { SimpleInfo } from 'new/elements/SimpleInfo';
import { Nexset } from 'new/entities/Nexset';
import DateUtils from 'js/lib/DateUtils';
import { Link } from 'react-router-dom';
import DocEditor from 'js/components/elements/editors/DocEditor';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_DATA_SET_DOC_REQUEST, UPDATE_DATA_SET_DOC_REQUEST } from 'js/constants/actionTypes';
import { updateDatasetDoc } from 'js/actions';
import { Stack } from 'new/elements/Stack';
import { Button } from 'new/elements/Button';
import { useModals } from 'new/hooks/useModals';
import { ModalEditDoc } from 'new/elements/ModalEditDoc';

interface NexsetOverviewProps {
  nexset: Nexset;
}

export function NexsetOverview(props: NexsetOverviewProps) {
  const { nexset } = props;
  const loadingDoc = useIsLoading(GET_DATA_SET_DOC_REQUEST);
  const { openModal } = useModals();

  const onEditInfo = () => {
    openModal(ModalEditDoc.modalConfig.name, {
      data: nexset,
      doc: nexset.doc,
      onUpdate: updateDatasetDoc,
      loadingChecks: [UPDATE_DATA_SET_DOC_REQUEST],
    });
  };

  if (!nexset) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <Typography variant="subtitle1">Basic details</Typography>
        <div>
          <div className={styles.row}>
            <SimpleInfo label="Nexset ID" value={nexset.id + ''} />
            <SimpleInfo
              label="Created on"
              value={DateUtils.getDateString(nexset.created_at, 'MMM D, YYYY [at] h:mmA z')}
              direction="flex-end"
            />
          </div>
          <div className={styles.row}>
            <SimpleInfo
              label={'from ' + (nexset.isDetected ? 'Source' : 'Nexset')}
              value={nexset?.source?.name}
            />
            <SimpleInfo
              label="Transformed nexsets"
              value={nexset.transformedCount + ''}
              direction="flex-end"
            />
          </div>
          <div className={styles.row}>
            <SimpleInfo label="Shared with" value={nexset?.sharesCount + ' users'} />
            <SimpleInfo
              label="Writing to destination"
              value={
                nexset?.dataSinks?.length
                  ? (nexset.dataSinks || []).map((sink) => <Link to="#">{sink.name}</Link>)
                  : 'None'
              }
              direction="flex-end"
            />
          </div>
        </div>
      </div>
      <div className={styles.section}>
        <Stack direction="row" alignItems="center" className={styles.informationTitle}>
          <Typography variant="subtitle1">Information</Typography>
          <Button onClick={onEditInfo}>Edit</Button>
        </Stack>
        <div className="detail-view preview-tab">
          <DocEditor data={nexset} doc={nexset.doc} isLoading={loadingDoc} readOnly />
        </div>
      </div>
    </div>
  );
}
